import { Icon } from "@validereinc/common-components";
import { formatInvestigationRecoverable } from "#src/view-models/investigations";
import { type InvestigationErrorType } from "@validereinc/domain";
import classNames from "classnames/bind";
import React from "react";
import styles from "./InvestigationDetailPage.module.scss";

const cx = classNames.bind(styles);

export type InvestigationErrorBlockProps = {
  error: InvestigationErrorType;
};

export const InvestigationErrorBlock = ({
  error,
}: InvestigationErrorBlockProps) => {
  const code =
    typeof error.code === "string" && error.code.length > 0
      ? error.code
      : "unknown";

  return (
    <div
      className={cx("error-block")}
      role="alert"
      data-testid="investigation-error-block"
    >
      <div className={cx("error-block__heading")}>
        <Icon variant="warning" />
        <span>Investigation failed</span>
      </div>
      <div className={cx("error-block__field")}>
        <span className={cx("error-block__label")}>Code:</span>
        <code>{code}</code>
      </div>
      <div className={cx("error-block__field")}>
        <span className={cx("error-block__label")}>Message:</span>
        {error.message || "(no message provided)"}
      </div>
      <div className={cx("error-block__field")}>
        <span className={cx("error-block__label")}>Recoverable:</span>
        {formatInvestigationRecoverable(error.recoverable)}
      </div>
    </div>
  );
};
